export default __webpack_public_path__ + "static/media/product-15.ec5112d0.webp";